import { render, staticRenderFns } from "./AnswerField.vue?vue&type=template&id=68004458&"
import script from "./AnswerField.vue?vue&type=script&lang=js&"
export * from "./AnswerField.vue?vue&type=script&lang=js&"
import style0 from "./AnswerField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports